/**
 * Ripple effect for buttons and cards
 */

import { prefersReducedMotion } from '../core/utils.js';

export class RippleEffect {
  #elements;
  #abortController = new AbortController();

  constructor() {
    if (prefersReducedMotion()) return;

    this.#elements = document.querySelectorAll('.project-card, .submit-btn, .hero-cta');
    this.#init();
  }

  #init() {
    const signal = this.#abortController.signal;

    this.#elements.forEach(el => {
      el.addEventListener('click', (e) => this.#createRipple(e, el), { signal });
    });
  }

  #createRipple(e, element) {
    const rect = element.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    
    const ripple = document.createElement('span');
    ripple.className = 'ripple';
    ripple.style.cssText = `
      width: ${size}px;
      height: ${size}px;
      left: ${e.clientX - rect.left - size / 2}px;
      top: ${e.clientY - rect.top - size / 2}px;
    `;

    element.style.position = 'relative';
    element.style.overflow = 'hidden';
    element.appendChild(ripple);

    // Remove after animation
    setTimeout(() => {
      ripple.remove();
    }, 600);
  }

  destroy() {
    this.#abortController.abort();
  }
}
